import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SalesService } from '../../../../services/sales.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LoaderComponent } from '../../../loader/loader.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { RecentInteractions, SalesOrder, gridPageRequest } from '../../../../model/common/common.model';
import _ from 'lodash';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { Table } from 'primeng/table';
import { PaymentReceiptService } from '../../../../services/payment-receipt.service';
import { catchError, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { CustomerService } from '../../../../services/customer.service';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { ReportCenterService } from '../../../../services/report-center.service';
import { InventoryService } from '../../../../services/inventory.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { EInvoiceService } from '../../../../services/einvoice.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-invoice-list',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent, ConfirmDialogModule],
  providers: [ConfirmationService],
  templateUrl: './invoice-list.component.html',
  styleUrl: './invoice-list.component.scss'
})
export class InvoiceListComponent {
  @ViewChild('dt1') dt1: Table | undefined;
  paginator: boolean | undefined;
  uniqueCustomerCodes: string[] = [];

  constructor(private paymentService: PaymentReceiptService, private router: Router, public dialogService: DialogService, public ref: DynamicDialogRef, private salesService: SalesService, private confirmationService: ConfirmationService, private messageService: MessageService, private customerService: CustomerService, private emailTemplateService: EmailTemplateService, private reportService: ReportCenterService, private inventoryService: InventoryService,
    private administratorService: AdministratorService, private porderservice: PurchaseorderService, private einvoiceService: EInvoiceService
  ) { }

  visible: boolean = false;
  loader: boolean = false;
  searchKey: any;
  listInvoice: SalesOrder[] = [];
  selectedOrder: SalesOrder[] = [];
  selectedStatus: any = { name: 'All' };
  CustomerCode: any;
  list: any[] = [];
  Data: any;
  path: string = '';
  companyInfo: any = {};
  properties = { invoiceNumber: 0 };
  ReportPath: any;
  OrderNumber: any;
  Status: any;
  isEinvoiceEnabled: boolean = false;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  pageRequestforstatus: gridPageRequest = {
    pageIndex: 1,
    pageSize: 50,
    id: 0
  }


  ngOnInit(): void {
    document.title = 'Invoice List';
    this.getInvoiceList();
    this.getEinvoiceSetting();
    this.getCompanyDetails();
    this.searchEffect();
  }

  create() {
    this.router.navigate(['/home/CreateInvoice']);
  }

  loadOrderList(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchOrder();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getInvoiceList();
    }
  }

  getInvoiceList() {
    this.loader = true;
    forkJoin({
      invoice: this.salesService.getInvoiceOrderStatus('INVOICE', this.pageRequest),
      draftInvoice: this.salesService.getInvoiceOrderStatus('DRAFT.INVOICE', this.pageRequest)
    }).subscribe({
      next: (result: any) => {
        const invoiceList = result.invoice?.invoice || [];
        //console.log(invoiceList);

        const draftInvoiceList = result.draftInvoice?.invoice || [];
        // this.listInvoice = [...invoiceList, ...draftInvoiceList].sort((a: any, b: any) => {
        //   const dateA = new Date(a.createdDate).getTime();
        //   const dateB = new Date(b.createdDate).getTime();
        //   return dateB - dateA;
        // });


        this.listInvoice = [...invoiceList, ...draftInvoiceList]
          .map((inv: any) => {
            const ackDate = inv.eInvoice?.ackDate;

            return {
              ...inv,
              isCancelExpired: ackDate
                ? this.isCancelExpired(ackDate)
                : false
            };
          })
          .sort((a: any, b: any) => {
            const dateA = new Date(a.createdDate).getTime();
            const dateB = new Date(b.createdDate).getTime();
            return dateB - dateA;
          });

        //console.log('Invoice List:', this.listInvoice);

        this.searchKey = undefined;

        this.uniqueCustomerCodes = [...new Set(this.listInvoice.map((inv: any) => inv.billToCustomerCode))];

        this.loader = false;
      },
      error: (error: any) => {
        console.error('Error fetching invoices:', error);
        this.loader = false;
      }
    });
  }


  editInvoice(data?: any) {
    if (data) {
      this.router.navigate(['/home/CreateInvoice'], { queryParams: { 'Data': data.salesOrderId }, skipLocationChange: false, });
    } else {
      const Data = JSON.stringify(this.selectedOrder[0].salesOrderId);
      this.router.navigate(['/home/CreateInvoice'], { queryParams: { 'Data': Data }, skipLocationChange: false, });
    }
  }

  deleteInvoice() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var salesOrderId = _.map(this.selectedOrder, 'salesOrderId');

        this.salesService.deleteSalesOrder(salesOrderId).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
            this.loader = false;
            this.selectedOrder = [];
            this.getInvoiceList();
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });

  }

  searchOrder() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }


    this.salesService.SearchSalesOrder(this.searchKey).subscribe(
      (data: any) => {
        if (Array.isArray(data)) {
          this.listInvoice = data.filter((order: any) =>
            order.salesOrderStatus === 'INVOICE' || order.salesOrderStatus === 'DRAFT.INVOICE'
          );
          this.pageRequest.pageSize = this.listInvoice.length;
          this.paginator = false;

        } else if (data && Array.isArray(data.salesOrder)) {
          this.listInvoice = data.salesOrder.filter((order: any) =>
            order.salesOrderStatus === 'INVOICE' || order.salesOrderStatus === 'DRAFT.INVOICE'
          );
          this.pageRequest.pageSize = this.listInvoice.length;
          this.paginator = false;

        } else {
          this.listInvoice = [];
        }

      },
      (error) => {
        console.error('Search error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }




  showReport(value: any): void {
    const formCode = 'Invoice';

    this.reportService.getReportName(formCode).subscribe({
      next: (report: any) => {
        const salesOrderNumber = value.salesOrderNumber;
        const sanitizedOrderNumber = salesOrderNumber.replace(/[^a-zA-Z0-9]/g, "_");
        document.title = sanitizedOrderNumber;
        this.ref = this.dialogService.open(ReportLookupComponent, {
          header: report.formName,
          width: '100%',
          data: {
            OrderNo: salesOrderNumber,
            ReportName: sanitizedOrderNumber,
            ReportPath: report.path
          }
        });
        this.ref.onClose.subscribe(() => {
          this.searchKey = '';
          document.title = 'Invoice List';
        });
      },
      error: (err: any) => {
        console.error('Report not found for form code:', formCode, err);
      }
    });
  }


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getInvoiceList();
    this.selectedOrder = [];
  }

  sendOrderEmail() {

    if (!this.selectedOrder || this.selectedOrder.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one order' });
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'Invoice';

    this.loader = true;
    let processedCount = 0;
    let successCount = 0;
    let skippedCount = 0;

    const totalOrders = this.selectedOrder.length;

    this.getUserDepartmentName().subscribe(departmentName => {

      this.selectedOrder.forEach(order => {

        this.reportService.getReportName(formCode).pipe(

          switchMap((report: any) => {
            if (!report?.path) {
              throw new Error('REPORT_MISSING');
            }
            const reportPath = report.path;

            return this.salesService.getSalesOrderById(order.salesOrderId).pipe(
              map(orderData => ({ orderData, reportPath }))
            );
          }),

          switchMap(({ orderData, reportPath }) => {
            if (!orderData?.customer?.email) {
              throw new Error('EMAIL_MISSING');
            }
            return this.customerService.getCustomerById(orderData.shipToCustomerId).pipe(
              map(shipToCustomer => ({ orderData, shipToCustomer, reportPath }))
            );
          }),

          switchMap(({ orderData, shipToCustomer, reportPath }) => {

            return this.emailTemplateService.getTemplate('order-email-template').pipe(
              map(template => {

                if (!template) {
                  throw new Error('TEMPLATE_MISSING');
                }

                const formatCurrency = (value: number) =>
                  `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

                const templateData = {
                  customerName: orderData.customer.customerName,
                  orderNumber: orderData.salesOrderNumber,
                  orderDate: new Date(orderData.orderDate).toLocaleDateString(),
                  shipToName: shipToCustomer?.customerName || 'N/A',
                  salespersonName: orderData.salesperson.salespersonName,
                  salespersonCode: orderData.salesperson.salespersonCode,
                  warehouseName: orderData.warehouse.warehouseName,
                  orderTotal: formatCurrency(orderData.orderTotal),
                  cgstTotal: formatCurrency(orderData.cgstTotal),
                  sgstTotal: formatCurrency(orderData.sgstTotal),
                  igstTotal: formatCurrency(orderData.igstTotal),
                  salesTaxTotal: formatCurrency(orderData.salesTaxTotal),
                  currentYear: new Date().getFullYear(),
                  companyName: this.companyInfo?.companyName || '',
                  companyEmail: this.companyInfo?.companyEmail || '',
                  companyPhone: this.companyInfo?.companyPhone || '',
                  companyWebsite: this.companyInfo?.companyWebsite || ''
                };
                return {
                  orderData,
                  emailBody: this.emailTemplateService.replacePlaceholders(template, templateData),
                  reportPath
                };
              })
            );
          }),

          switchMap(({ orderData, emailBody, reportPath }) => {

            const emailData = {
              EmailToId: orderData.customer.email,
              EmailToName: orderData.customer.customerName,
              EmailSubject: `Order ${orderData.salesOrderNumber} from ${this.companyInfo?.companyName || 'our company'}`,
              EmailBody: emailBody,
              OrderNumber: orderData.salesOrderNumber,
              OrderType: 'SalesOrder',
              TenantId: tenant,
              ReportPath: reportPath,
              DepartmentName: departmentName
            };

            return this.salesService.SendMail(emailData).pipe(
              map(response => ({
                response,
                orderData
              }))
            );
          }),

          catchError(err => {
            console.error('Invoice email skipped:', err.message);
            skippedCount++;
            processedCount++;
            return of(null);
          })

        ).subscribe({
          next: (result) => {

            if (result !== null) {
              successCount++;
              this.createRecentInteractions(result.orderData, departmentName);
            }

            processedCount++;

            if (processedCount === totalOrders) {
              this.loader = false;

              if (successCount === 0) {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'No Emails Sent',
                  detail: 'Invoice emails were not sent because required data (report / email / template) was missing.'
                });
                this.selectedOrder = [];
              }
              else if (successCount < totalOrders) {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Partial Success',
                  detail: `${successCount} invoice email(s) sent. ${skippedCount} skipped.`
                });
                this.selectedOrder = [];
              }
              else {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: `Successfully sent ${successCount} invoice email(s).`
                });
              }
              this.selectedOrder = [];
            }
          },
          error: () => {
            processedCount++;
            skippedCount++;

            if (processedCount === totalOrders) {
              this.loader = false;
              this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Some invoice emails failed to send.'
              });
            }
          }
        });
      });
    });
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  createRecentInteractions(data: any, departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: 'Send Mail',
          from: fromEmail,
          to: data.customer.email,
          subject: `Order ${data.salesOrderNumber} ${data.status || ''}`,
          customerNumber: data.customer.customerCode,
          refId: data.salesOrderId,
          description: "Invoice Order successfully placed",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => {
            this.getInvoiceList();
            console.log('Recent interaction created:', res);
          },
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Invoice No', 'Order Date', 'Bill To Customer', 'Ship To Customer', 'Order Total', 'Reqd Date']; private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

  paymentStatusColors: { [key: string]: string } = {
    'Paid': '#28a745',
    'Overdue': '#dc3545',
    'Open': '#007bff',
    'Partially Paid': '#ffc107'
  };

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  showDraftAlert() {
    this.messageService.add({
      severity: 'warn',
      summary: 'Print Restricted',
      detail: 'Printing is restricted. Please save this as a Final Invoice first.',
      life: 3000
    });
  }


  irn: string = '';
  qrCode: string = '';
  isGeneratingIRN: boolean = false;



  // confirmGenerateIRN() {
  //   //if (!this.isEinvoiceEnabled) return;

  //   if (!this.selectedOrder || this.selectedOrder.length !== 1) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Warning',
  //       detail: 'Please select one record'
  //     });
  //     return;
  //   }

  //   this.confirmationService.confirm({
  //     header: 'Confirm IRN Generation',
  //     message: 'Do you want to generate E-Invoice for this record?',
  //     icon: 'pi pi-question-circle',

  //     acceptLabel: 'Yes',
  //     rejectLabel: 'No',

  //     acceptButtonStyleClass: 'p-button-success',
  //     rejectButtonStyleClass: 'p-button-secondary',

  //     accept: () => {
  //       this.generateIRN();
  //     },
  //     reject: () => {
  //       this.messageService.add({
  //         severity: 'info',
  //         summary: 'Cancelled',
  //         detail: 'IRN generation cancelled'
  //       });
  //       this.selectedOrder = [];

  //     }
  //   });
  // }

  confirmGenerateIRN() {

    if (!this.selectedOrder || this.selectedOrder.length !== 1) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select one record'
      });
      return;
    }

    const order = this.selectedOrder[0];

    this.einvoiceService.validateIRN(order.salesOrderId).subscribe({
      next: () => {
        this.openConfirmPopup();
      },
      error: (err) => {

        console.log('FULL ERROR:', err);

        if (err.error?.errors && Array.isArray(err.error.errors)) {

          err.error.errors.forEach((msg: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Validation Error',
              detail: msg
            });
          });

        }
        else if (err.error?.message) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error.message
          });
        }
        else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Validation failed'
          });
        }
        this.selectedOrder = [];
      }
    });
  }




  openConfirmPopup() {
    this.confirmationService.confirm({
      header: 'Confirm IRN Generation',
      message: 'Do you want to generate E-Invoice for this record?',
      icon: 'pi pi-question-circle',

      acceptLabel: 'Yes',
      rejectLabel: 'No',

      acceptButtonStyleClass: 'p-button-success',
      rejectButtonStyleClass: 'p-button-secondary',

      accept: () => {
        this.generateIRN();
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelled',
          detail: 'IRN generation cancelled'
        });
        this.selectedOrder = [];
      }
    });
  }


  generateIRN() {
    const order = this.selectedOrder[0];
    //order.CreatedBy = localStorage.getItem('username') || ""
    const payload = {
      userName: localStorage.getItem('username') || ''
    };

    this.isGeneratingIRN = true;

    this.einvoiceService.generateIRN(order.salesOrderId, payload).subscribe({
      next: (res: any) => {
        this.isGeneratingIRN = false;

        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: 'E-Invoice Generated Successfully'
        // });
        // this.selectedOrder = [];

        // this.getInvoiceList();

        if (res.status === 'Success') {

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'E-Invoice Generated Successfully'
          });

          this.getInvoiceList();

        } else {

          this.messageService.add({
            severity: 'error',
            summary: 'IRN Failed',
            detail: res.errorMessage || 'IRN generation failed'
          });
        }

        this.selectedOrder = [];
      },
      error: (err) => {
        this.isGeneratingIRN = false;

        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to generate E-Invoice'
        // });

        if (err.error?.errors) {
          err.error.errors.forEach((msg: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: msg
            });
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'IRN failed'
          });
        }

        console.error('IRN Error:', err);
      }
    });
  }



  // get isIRNAllowed(): boolean {
  //   if (this.selectedOrder?.length !== 1) return false;

  //   const order = this.selectedOrder?.[0];
  //   console.log(order);

  //   if (!order) return false;

  //   const paymentOpen = order.paymentStatus?.toLowerCase() === 'open';
  //   const status = order.eInvoice?.status?.toLowerCase();

  //   return paymentOpen && (
  //     !order.eInvoice ||
  //     !status ||
  //     status === 'not generated' ||
  //     status === 'failed'
  //   );
  // }

  get isIRNAllowed(): boolean {
    if (this.selectedOrder?.length !== 1) return false;

    const order = this.selectedOrder?.[0];
    //console.log(order);

    if (!order) return false;

    //const paymentOpen = order.paymentStatus?.toLowerCase() === 'open';
    const status = order.eInvoice?.status?.toLowerCase();
    const isInvoice = (order as any).salesOrderStatus?.toLowerCase() === 'invoice';


    // return paymentOpen && isInvoice && (

    return isInvoice && (
      !order.eInvoice ||
      !status ||
      status === 'not generated' ||
      status === 'failed'
    );
  }



  getEInvoiceStatusClass(invoice: any): string {
    const status = invoice?.eInvoice?.status?.toLowerCase();

    switch (status) {
      case 'success':
        return 'text-green-500';

      case 'failed':
      case 'cancel failed':
        return 'text-red-500';

      case 'cancelled':
        return 'text-gray-500';

      default:
        return 'text-blue-500'; // Not Generated / Unknown
    }
  }



  get isCancelAllowed(): boolean {
    return this.selectedOrder?.length === 1 &&
      this.selectedOrder[0]?.eInvoice?.status?.toLowerCase() === 'success';
  }



  // confirmCancelIRN() {
  //   //if (!this.isEinvoiceEnabled) return;

  //   if (!this.selectedOrder || this.selectedOrder.length !== 1) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Warning',
  //       detail: 'Please select one invoice'
  //     });
  //     return;
  //   }

  //   this.confirmationService.confirm({
  //     message: 'Are you sure you want to cancel this IRN?',
  //     header: 'Confirm',
  //     icon: 'pi pi-exclamation-triangle',
  //     accept: () => {
  //       this.cancelIRN();
  //     }
  //   });
  // }


  // cancelIRN() {
  //   const order = this.selectedOrder[0];

  //   this.isGeneratingIRN = true; // reuse loader

  //   this.einvoiceService.cancelIRN(order.salesOrderId).subscribe({
  //     next: (res: any) => {
  //       this.isGeneratingIRN = false;

  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'IRN Cancelled Successfully'
  //       });

  //       this.selectedOrder = [];

  //       this.getInvoiceList(); // refresh
  //     },
  //     error: (err) => {
  //       this.isGeneratingIRN = false;

  //       // this.messageService.add({
  //       //   severity: 'error',
  //       //   summary: 'Error',
  //       //   detail: err.error?.message || 'Failed to cancel IRN'
  //       // });

  //       console.error('Cancel IRN Error:', err);
  //     }
  //   });
  // }




  showSuccess(msg: string) {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: msg
    });
  }

  showError(msg: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: msg
    });
  }
  // get isCancelAllowed(): boolean {
  //   if (!this.selectedOrder || this.selectedOrder.length !== 1) return false;

  //   const inv = this.selectedOrder[0].eInvoice;

  //   if (!inv || inv.status !== 'Success') return false;

  //   const ackDate = new Date(inv.ackDate);
  //   const now = new Date();

  //   const diffHours = (now.getTime() - ackDate.getTime()) / (1000 * 60 * 60);

  //   return diffHours <= 24;
  // }


  // getEinvoiceSetting(): void {
  //   this.inventoryService
  //     .getUnitByAppKey('enable_einvoice')
  //     .subscribe({
  //       next: (res: any) => {
  //         this.isEinvoiceEnabled =
  //           res?.data?.toString().toUpperCase() === 'Y';
  //       },
  //       error: () => {
  //         this.isEinvoiceEnabled = false;
  //       }
  //     });
  // }

  getEinvoiceSetting(): void {
    this.einvoiceService.getEInvoiceStatus()
      .subscribe({
        next: (res: any) => {
          this.isEinvoiceEnabled = res.isEInvoiceEnabled;
        },
        error: () => {
          this.isEinvoiceEnabled = false;
        }
      });
  }

  showCancelDialog: boolean = false;
  submitted: boolean = false;

  cancelReasons = [
    { label: 'Duplicate Invoice', value: 1 },
    { label: 'Data Entry Mistake', value: 2 },
    { label: 'Order Cancelled', value: 3 },
    { label: 'Others', value: 4 }
  ];

  selectedCancelReason: number | null = null;
  cancelRemark: string = '';

  confirmCancelIRN() {
    if (!this.selectedOrder || this.selectedOrder.length !== 1) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select one invoice'
      });
      return;
    }

    const order = this.selectedOrder[0];

    const ackDate = order.eInvoice?.ackDate;
    //console.log("ackDate: " + order.eInvoice?.irn);


    if (ackDate && this.isCancelExpired(ackDate)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Cancellation Not Allowed',
        detail: 'Cancellation is allowed only within 24 hours. Please issue a Credit Note.'
      });
      return;
    }


    this.showCancelDialog = true; // open popup
  }
  submitCancelIRN() {
    this.submitted = true;

    if (!this.selectedCancelReason) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select cancel reason'
      });
      return;
    }

    if (!this.cancelRemark || this.cancelRemark.trim() === '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter remark'
      });
      return;
    }

    this.showCancelDialog = false;

    this.cancelIRN(); // call API
  }
  cancelIRN() {
    const order = this.selectedOrder[0];

    const payload = {
      salesOrderId: order.salesOrderId,
      reason: this.selectedCancelReason?.toString(),
      remarks: this.cancelRemark
    };


    this.isGeneratingIRN = true;

    this.einvoiceService.cancelIRN(payload).subscribe({
      next: (res: any) => {
        this.isGeneratingIRN = false;

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'IRN Cancelled Successfully'
        });

        this.selectedOrder = [];
        this.selectedCancelReason = null;
        this.cancelRemark = '';

        this.getInvoiceList();
      },
      error: (err) => {
        this.isGeneratingIRN = false;
        //console.error('Cancel IRN Error:', err);

        this.messageService.add({
          severity: 'error',
          summary: 'IRN Cancellation Failed',
          detail: err.error?.message || 'Unable to cancel IRN'
        });
        //this.selectedOrder = [];
      }
    });
  }
  isCancelExpired(ackDate: Date | string): boolean {
    const ack = new Date(ackDate);
    const now = new Date();

    return (now.getTime() - ack.getTime()) > 24 * 60 * 60 * 1000;
  }


  onCancelDialogClose() {
    this.showCancelDialog = false;
    this.submitted = false;
    this.selectedCancelReason = null;
    this.cancelRemark = '';
  }


  getCancelStatus(invoice: any): string {
    const status = invoice.eInvoice?.status;

    if (!status || status === 'Not Generated') return 'Active';
    if (status === 'Cancelled') return 'Cancelled';

    if (status === 'Success') {
      return invoice.isCancelExpired ? 'Expired' : 'Active';
    }

    return '-';
  }

  getCancelStatusClass(invoice: any): string {
    const status = this.getCancelStatus(invoice);

    switch (status) {
      case 'Active':
        return 'active-badge';
      case 'Expired':
        return 'expired-badge';
      case 'Cancelled':
        return 'cancelled-badge';
      default:
        return '';
    }
  }


}


